import session from '../../auth_api/session'

const URL = process.env.VUE_APP_API_URL
const appURL = URL + 'gis_gmp/api/'

export default {
  namespaced: true,
  state: {
    search: '',
    selected: [],
    pagination: {
      rowsPerPage: 10,
      sortBy: null,
      totalItems: 0,
      page: 1
    },
    listExportPayment: { 'results': [] },
    cardExportPayment: {
      id: null,
      export_payment_html: ''
    }
  },
  mutations: {
    setSearch (state, payload) {
      state.search = payload
    },
    setSelected (state, payload) {
      state.selected = payload
    },
    setListExportPayment (state, payload) {
      state.listExportPayment = payload
    },
    setCardExportPayment (state, payload) {
      state.cardExportPayment = payload
    }
  },
  actions: {
    fetchListExportPayment ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpListExportPayment'
        // commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        if ((0 + payload.pageId) > 1) {
          params['page'] = payload.pageId
        }
        if (payload.search > '') {
          params['search'] = payload.search
        }
        let _url = appURL + 'export-payment/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setListExportPayment', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchCardExportPayment ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'gis_gmpFetchCardExportPayment'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'export-payment-data-html/' + payload.id + '/'
        session.get(_url)
          .then(response => {
            commit('setCardExportPayment', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    search (state) {
      return state.search
    },
    pagination (state) {
      return state.pagination
    },
    selected (state) {
      return state.selected
    },
    listExportPayment (state) {
      return state.listExportPayment
    },
    cardExportPayment (state) {
      return state.cardExportPayment
    }
  }
}
